import $ from 'jquery';
import 'cookieconsent';

import './core/fab-menu'
import './core/mobile-navigation'
import './core/radio-buttons-group'
import './core/sidebar'
import './core/search'
import './core/global-buttons'

window.CS = {
    urlLanguageToken: null,
};

window.CS.Constants = {
    newModelId: -1,
    fuelTypeId: {
        gasoline: 1,
        diesel: 2,
        lpg: 3,
        cng: 4,
        electricity: 5,
    },
    vehicleTypeId: {
        car: 1,
        motorcycle: 2,
        truck: 3,
    },
};

CS.User = new function () {
    this.user = {
        user_id: null,
        username: null,
        access_token: null,
    };

    this.setUser = function (u) {
        this.user = u;
    };

    this.getUser = function () {
        return this.user;
    };

    this.isGuest = function () {
        return !this.user.user_id;
    };
};

CS.API = new function () {
    this.apiEndpoint = null;

    this.setApiEndpoint = function (endpoint) {
        this.apiEndpoint = endpoint;
    };

    this.getAuthHeaders = function () {
        if (CS.User.isGuest()) {
            return {};
        } else {
            return {
                Authorization: 'Bearer ' + CS.User.user.access_token
            }
        }
    };

    this.apiAjaxRequest = function (apiPath, params) {
        const options = $.extend({}, params);
        options.url = this.apiEndpoint + apiPath;
        options.headers = $.extend({}, options.headers, this.getAuthHeaders());
        return $.ajax(options)
    };

    this.favoriteVenueRequest = (method, data) => {
        return window.CS.API.apiAjaxRequest('/favorite-venues', {
            data: data,
            method: method,
        });
    };

    this.venueListFavorites = (params) => {
        return this.favoriteVenueRequest('GET', params);
    };

    this.venueAddFavorite = (venueId) => {
        return this.favoriteVenueRequest('POST', {
            venue_id: venueId
        });
    };

    this.venueRemoveFavorite = (venueId) => {
        return this.favoriteVenueRequest('DELETE', {
            venue_id: venueId
        });
    };

    this.vehicleImageDelete = (vehicleImageGuid) => {
        return window.CS.API.apiAjaxRequest('/vehicle-images/' + vehicleImageGuid, {
            method: 'DELETE',
        });
    };

    this.vehicleImageMarkDefault = (vehicleImageGuid) => {
        return window.CS.API.apiAjaxRequest('/vehicle-images/' + vehicleImageGuid + '/mark-default', {
            method: 'POST',
        });
    };

    this.getVehicleGalleryItems = (vehicleGuid) => {
        return window.CS.API.apiAjaxRequest('/vehicles/' + vehicleGuid + '/images');
    };
};
